import { createContext, useContext, useMemo } from 'react';
import { getStoredAuth, isAdmin, isAuthenticated, logout as authLogout } from '../services/authService';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const auth = useMemo(() => getStoredAuth(), []);

  const value = {
    ...auth,
    isAuthenticated: isAuthenticated(),
    isAdmin: isAdmin(),
    logout: authLogout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
